import { render, staticRenderFns } from "./CatalogueHolidays.vue?vue&type=template&id=755b294e&"
import script from "./CatalogueHolidays.vue?vue&type=script&lang=js&"
export * from "./CatalogueHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports